import React, { useState } from 'react';
import '../css/packages.css';

import Heritage1 from '../assets/package/heritage1.jpg';
import Heritage2 from '../assets/package/heritage2.jpg';
import Heritage3 from '../assets/package/heritage3.jpg';
import Heritage4 from '../assets/package/heritage1.jpg';

import Pilgrimage1 from '../assets/package/pilgrimage1.jpg';
import Pilgrimage2 from '../assets/package/pilgrimage2.jpg';
import Pilgrimage3 from '../assets/package/pilgrimage3.jpg';

import Leisure1 from '../assets/package/leisure1.jpg';
import Leisure2 from '../assets/package/leisure2.jpg';
import Leisure3 from '../assets/package/leisure3.jpg';
import Leisure4 from '../assets/package/leisure4.jpg';

import Wildlife1 from '../assets/package/wildlife1.jpg';
import Wildlife2 from '../assets/package/wildlife2.jpg';
import Wildlife3 from '../assets/package/wildlife3.jpg';
import Wildlife4 from '../assets/package/wildlife4.jpg';

const Packages = () => {
    const [selectedCategory, setSelectedCategory] = useState('Heritage');

    const packagesData = {
        Heritage: [
            { img: Heritage1, title: 'MP Historical Tour', route: 'Gwalior - Khajuraho - Orchha - Gwalior', duration: '4 Night / 5 Days' },
            { img: Heritage2, title: 'World Heritage', route: 'Bhopal - Sanchi', duration: '2 Night / 3 Days' },
            { img: Heritage3, title: 'MP Splendour Heritage', route: 'Jhansi - Orchha - Khajuraho', duration: '2 Night / 3 Days' },
            { img: Heritage4, title: 'Jewel of Madhya Pradesh', route: 'Gwalior - Khajuraho - Orchha - Panna - Jablpur', duration: '4 Night / 5 Days' }
        ],
        Pilgrimage: [
            { img: Pilgrimage1, title: 'Journey To Jyotirlingas', route: 'Indore - Ujjain - Omkareshwar - Maheshwari - Mandu - Indore', duration: '4 Night / 5 Days' },
            { img: Pilgrimage2, title: 'Journey To Jyotirlingas With Mandu Heritage', route: 'Indore - Mandu - Ujjain - Omkareshwar - Maheshwar', duration: '4 Night / 5 Days' },
            { img: Pilgrimage3, title: 'Panch Jyotirlinga Tour', route: 'Pune - Rajguru - Bhimashankar - Shani - Shignapur - Aurangabad - Grineshwar - Shirdi - Triambakeshwar - Nashik - Omkareshwar - Ujjain', duration: '7 Night / 8 Days' }
        ],
        Leisure: [
            { img: Leisure1, title: 'Satpura Queen Tour', route: 'Pipariya - Pichmarhi', duration: '3 Night / 4 Days' },
            { img: Leisure2, title: 'Sailani Island Tour', route: 'Indore - Sailani Island', duration: '3 Night / 4 Days' },
            { img: Leisure3, title: 'Exotic Pichmarhi Tour', route: 'Pipariya - Pichmarhi', duration: '3 Night / 4 Days' },
            { img: Leisure4, title: 'Golden Triangle Tour', route: 'Pipariya - Pichmarhi - Kanha - Bhedaghat - Jablpur', duration: '5 Night / 6 Days' }
        ],
        Wildlife: [
            { img: Wildlife1, title: 'Temples & Tigers', route: 'Bandhavgarh - Amarkantak - Bhedaghat - Jabalpur', duration: '3 Night / 4 Days' },
            { img: Wildlife2, title: 'Call Of Tigers', route: 'Jabalpur - Kanha', duration: '2 Night / 3 Days' },
            { img: Wildlife3, title: 'Mowglis Trail', route: 'Nagpur - Pench', duration: '2 Night / 3 Days' },
            { img: Wildlife4, title: 'Wilderness of MP', route: 'Jabalpur - Bhedaghat - Kanha - Bandhavgarh', duration: '5 Night / 6 Days' }
        ]
    };

    return (
        <div className='packages-section'>
            <h1>MP Tour Packages</h1>
            <div className="packages-container">
                {/* Category Selection */}
                <div className="packages-header">
                    <span onClick={() => setSelectedCategory('Heritage')} className={selectedCategory === 'Heritage' ? 'active' : ''}>
                        <i class="fa-brands fa-fort-awesome"></i>
                        <h3>Heritage Tours</h3>
                    </span>
                    <span onClick={() => setSelectedCategory('Pilgrimage')} className={selectedCategory === 'Pilgrimage' ? 'active' : ''}>
                        <i class="fa-solid fa-gopuram"></i>
                        <h3>Pilgrimage Tours</h3>
                    </span>
                    <span onClick={() => setSelectedCategory('Leisure')} className={selectedCategory === 'Leisure' ? 'active' : ''}>
                    <i class="fa-brands fa-pagelines"></i>
                        <h3>Leisure Tours</h3>
                    </span>
                    <span onClick={() => setSelectedCategory('Wildlife')} className={selectedCategory === 'Wildlife' ? 'active' : ''}>
                        <i class="fa-solid fa-paw"></i>
                        <h3>Wildlife Tours</h3>
                    </span>
                </div>

                {/* Package List Based on Selection */}
                <div className="packages-list">
                    {packagesData[selectedCategory].map((pkg, index) => (
                        <div className="package-card" key={index}>
                            <img src={pkg.img} alt={pkg.title} />
                            <div className="package-card-content">
                                <h4>{pkg.title}</h4>
                                <span>{pkg.route}</span>
                                <div className="package-duration">
                                    {pkg.duration}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Packages;
